(ns portal.advertiser-modal.db
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(defn url?
  [s]
  (re-find #"^https?://[^ ]+$" s))

(spec/def ::name
  (spec/and string?
            (complement str/blank?)))

(spec/def ::code
  (spec/and string?
            (complement str/blank?)))

(spec/def ::backupLandingPageUrl
  (spec/and (complement str/blank?)
            url?))

(spec/def ::value
  (spec/keys :req-un [::name ::code ::backupLandingPageUrl]))

(p/defphraser (complement str/blank?)
  [_ problem]
  {:message "The field should not be empty"
   :in (:in problem)
   :problem problem})

(p/defphraser string?
  [_ problem key]
  {:message "The field should be a string"
   :in (:in problem)
   :problem problem})

(p/defphraser url?
  [_ problem]
  {:message "The field should be a valid URL"
   :in (:in problem)
   :problem problem})

(def initial-value
  {:name ""
   :code ""
   :backupLandingPageUrl ""})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.advertiser-create ::value)))

(form/register-form {:namespace :form.advertiser-create
                     :initial-value initial-value
                     :validate-form validate-form})

(def use-bind-control (partial form/use-bind-control :form.advertiser-create))
(def use-error-message (partial form/use-error-message :form.advertiser-create))

(rf/reg-event-fx :form.advertiser-create/create-product-store
  (fn [_ [_ advertiser]]
    {:fx [[:async-flow {:id :create-product-store
                        :first-dispatch [:resource.auth/refresh-token]
                        :rules [{:when :seen?
                                 :events :resource.auth/refresh-token-success
                                 :halt? true
                                 :dispatch [:resource.product/create-store (:id advertiser)]}]}]]}))
